module.exports = __webpack_public_path__ + "static/media/img_04.6346f1a2.jpg";